import { render, staticRenderFns } from "./CustomersDropdown.vue?vue&type=template&id=19090246&scoped=true"
import script from "./CustomersDropdown.vue?vue&type=script&lang=js"
export * from "./CustomersDropdown.vue?vue&type=script&lang=js"
import style0 from "./CustomersDropdown.vue?vue&type=style&index=0&id=19090246&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19090246",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_diego/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19090246')) {
      api.createRecord('19090246', component.options)
    } else {
      api.reload('19090246', component.options)
    }
    module.hot.accept("./CustomersDropdown.vue?vue&type=template&id=19090246&scoped=true", function () {
      api.rerender('19090246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/common/dashboard/banner-builder/components/CustomersDropdown.vue"
export default component.exports